import { i18n } from '@lingui/core';
import { Text } from '@mindbaz/ui-v2';
import { uniqueId } from 'lodash';

import { Banner, SpanColor } from 'pages/Features/styledComponents';

const NewFeatureBanner = ({ newFeature }: { newFeature: string }) => {
  const message = i18n._('features.newFeatureBanner.safesend');

  const renderWithBold = (msg: string) => {
    const parts = msg.split(/<bold>(.*?)<\/bold>/);
    return (
      <>
        {parts.map((part, i) =>
          i % 2 === 1 ? <SpanColor key={uniqueId()}>{part}</SpanColor> : part
        )}
      </>
    );
  };

  return (
    <div>
      {newFeature && (
        <Banner>
          <Text align="center">{renderWithBold(message)}</Text>
        </Banner>
      )}
    </div>
  );
};

export default NewFeatureBanner;
